export default __webpack_public_path__ + "e2fc2ddce7db034407635aad598dfd60.png";